module.exports = __webpack_public_path__ + "img/cases_pdjc.5018c127.jpg";